import React from 'react';
import { FaWhatsapp, FaInstagram, FaFacebook } from 'react-icons/fa';

const SocialMediaLinks = () => {
  return (
    <div>  

      
      {/* WhatsApp */}
      <div className="whatsapp social-icon" aria-label="WhatsApp">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://api.whatsapp.com/send?phone=+9607899660&text=Hello"
          title="Contact via WhatsApp"
        >
          <div className="contact_icon">
            <FaWhatsapp size={24} aria-hidden="true" />
          </div>
        </a>
      </div>

      {/* Instagram */}
      <div className="instagram social-icon" aria-label="Instagram">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.instagram.com/drswatichavhan_psychiatrist/"
          title="Visit our Instagram"
        >
          <div className="contact_icon">
            <FaInstagram size={24} aria-hidden="true" />
          </div>
        </a>
      </div>

      {/* Facebook */}
      <div className="facebook social-icon" aria-label="Facebook">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/profile.php?id=61572319768645#"
          title="Visit our Facebook Page"
        >
          <div className="contact_icon">
            <FaFacebook size={24} aria-hidden="true" />
          </div>
        </a>
      </div>
    </div>
  );
}

export default SocialMediaLinks;
